import rtti from '@/sui/tools/rtti'

function mergeShallow (f, s) {
  return Object.assign({}, f, s)
}

function mergeDeep (...objects) {
  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key]
      const oVal = obj[key]

      if (rtti.isArray(pVal) && rtti.isArray(oVal)) {
        const count = pVal.length
        prev[key] = []
        for (let i = 0; i !== oVal.length; ++i) {
          if (i < count && rtti.isObject(pVal[i]) && rtti.isObject(oVal[i])) {
            prev[key].push(mergeDeep(pVal[i], oVal[i]))
          } else {
            prev[key].push(oVal[i])
          }
        }
      } else if (rtti.isObject(pVal) && rtti.isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal)
      } else {
        prev[key] = oVal
      }
    })

    return prev
  }, {})
}

export default function (first, second, deep) {
  if (deep) {
    return mergeDeep(first, second)
  }
  return mergeShallow(first, second)
}
